module.exports = __webpack_public_path__ + "img/info-icon.7b4c5d41.svg";